export function isDateIntersect(startA: number, endA: number, startB: number, endB: number) {
  if (startA <= startB && startB <= endA) return true;
  if (startA <= endB   && endB   <= endA) return true;
  if (startB <  startA && endA   <  endB) return true;
  return false;
}
